import React, { useState } from 'react'
import { Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom'
import { linkTo, translate } from '../../assets/js/functions';
import './assets/scss/styles.scss';

export default function Breadcrumbs ({beforeData, staticData, preUrl, currentSite, currentSiteColor}){

    const [data] = useState(null)
    const navigate = useNavigate()

    function _redirect(url){
        navigate(linkTo(url), { replace: true })
        window.location.reload(false);
    }

    return (
        <div id="breadcrumbs">
            <Container>
                <Link to={linkTo("/")} className="item">{translate("Inicio")}</Link>
                {
                    beforeData && beforeData.map(res => <Link to={linkTo(res.url)} key={res.name} className="item" onClick={() => _redirect(res.url)}>{res.name}</Link>)
                }
                {
                    staticData ? staticData.map(res => <Link to={linkTo(preUrl ? preUrl+res.url : res.url)} key={res.name} className="item" onClick={() => _redirect(preUrl ? preUrl+res.url : res.url)}>{res.name}</Link>) :
                    (data && data.map(res => <Link to={linkTo(res.term_id)} key={res.term_id} className="item" onClick={() => _redirect(res.term_id)}>{res.term}</Link>))
                }
                {
                    currentSite && <Link to={linkTo("#")} key={currentSite} style={{color: currentSiteColor}} className="item current-item">{currentSite}</Link>
                }
            </Container>
        </div>
    )
    return null;
}

